<template>
    <div>
        <v-row class="mt-6 mb-1 hidden-md-and-down">
            <v-card elevation="5" width="100%" class="main-buttons-container mx-3">
                <v-btn-toggle v-model="$store.state.reporteMenuOption" tile color="primary" shaped mandatory group
                    v-if="ver">
                    <template v-for="(item, i) in menu">
                        <v-btn :value="item.valor" @click="pushTo(item)" v-if="item.permisos == null"
                               :style="ocultar(item.valor)" :key="i">
                            <span class="hidden-sm-and-down">{{ item.omdescripcion }}</span>
                        </v-btn>
                        <v-btn :value="item.valor" @click="pushTo(item)" v-if="item.permisos == 1"
                               :style="ocultar(item.valor)" :key="i">
                            <span class="hidden-sm-and-down">{{ item.omdescripcion }}</span>
                        </v-btn>
                    </template>
                </v-btn-toggle>
            </v-card>
        </v-row>
        <div class="reporte-menu mt-4 hidden-lg-and-up">
            <vs-collapse class="title-card-style menu-header-bg mb-1" style="height: 100% !important">
                <vs-collapse-item :open="vercoll" not-arrow class="collapsable-container" >
                    <div id="menuPickerCollapsable" slot="header" class="menu-header-bg" >
                        <p class="card-title-text">Menú</p>
                    </div>
                    <v-container class="pt-5 px-4 pb-0">
                        <v-row>

                            <template v-for="(item, i) in menu">
                                <v-col cols="12" v-if="item.permisos == null" :style="ocultar(item.valor)" :key="i">
                                    <v-btn block text color="black" :value="item.omdescripcion" @click="pushTo(item)">
                                        {{ item.omdescripcion }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" v-if="item.permisos == 1" :style="ocultar(item.valor)" :key="i">
                                    <v-btn block text color="black" :value="item.omdescripcion" @click="pushTo(item)">
                                        {{ item.omdescripcion }}
                                    </v-btn>
                                </v-col>
                            </template>
                        </v-row>
                    </v-container>
                </vs-collapse-item>
            </vs-collapse>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';
export default {
    data() {
        return {
            reporte: {},
            menu: [],
            mobileMenuShowedName: "",
            ver: false,
            desconclusionPer: false,
            user: '',
            vercoll: false,
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage", "permission"]),
        ...mapGetters(["getUser", "THEME_STATE"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    watch: {
        //"$store.state.reporteMenuOption"(val) {
        //    if (val == "NoView") {
        //        this.setMobileMenuSelectedOption("NoView");
        //    } else
        //        this.setMobileMenuSelectedOption(val);
        //    //this.getInitialData();
        //},
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        ocultar(valor) {
            if (valor == 'NoView') {
                return 'display: none';
            }
            else
                return '';
        },
        pushTo(value) {
            if (value == 'Detalle General') {
                this.$emit('Pagina', 'Detalle General');

            }
            else {
                let vista = value.valor;
                this.$emit('Pagina', vista);
            }
            this.vercoll = false;
        },

        async ObtenerMenu() {
            let formdata = new FormData();
            formdata.append("nrreporte", this.reporte.nrreporte);
            formdata.append("svindice", this.reporte.svindice);
            formdata.append("aiclave", this.reporte.aiclave);
            formdata.append("uslogin", this.user);
            await Asistencia.ObtenerMenu(formdata).then(data => {
                this.ver = true;
                this.menu = data.data;
                this.menu.unshift({
                    id: 0,
                    omdescripcion: 'Detalle General',
                    permisos: null,
                    valor: 'Detalle General',
                });
                this.menu.push({
                    id: 0,
                    omdescripcion: 'No view',
                    permisos: null,
                    valor: 'NoView',
                });

            });
        },
        setMobileMenuSelectedOption(value) {
            switch (value) {
                case "Detalle General":
                    this.mobileMenuShowedName = "Detalle General";
                    break;
                case "Honorario":
                    this.mobileMenuShowedName = "Honorarios";
                    break;
                case "LiberacionVehExpJur":
                    this.mobileMenuShowedName = "Liberación Vehículo";
                    break;
                case "VolanteExpJur":
                    this.mobileMenuShowedName = "Volante Jur.";
                    break;
                case "GarantiasExpJur":
                    this.mobileMenuShowedName = "Garantías";
                    break;
                case "DesconclusionExpJur":
                    this.mobileMenuShowedName = "Desconclusión";
                    break;
                case "ContraloriaExpJur":
                    this.mobileMenuShowedName = "Contraloría";
                    break;
                case "NoView":
                    this.mobileMenuShowedName = "Men\u00FA";
                    break;
                default:
                    this.changeReporteMenuOption(value);
                    this.mobileMenuShowedName = value;
                    break;
            }
        },
        async Permisos() {
            if (this.reporte.aiclave == 1) {
                //Asis Jur
                await MetodosGenerales.verificarPermisoSolo(
                    this.domain.domainNameForApi,
                    "VerificarPermiso",
                    "91"
                ).then((response) => {
                    if (response.data.length > 0) {
                        response.data.forEach((object) => {
                            if (object.peclave == 91) this.desconclusionPer = true;
                        });
                    }
                });
            }
            else if (this.reporte.aiclave == 5) {
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '165').then(response => {
                    if (response.data.length > 0) {
                        response.data.forEach(object => {
                            if (object.peclave == 165)
                                this.desconclusionPer = true;

                        });
                    }
                });
            }
            else if (this.reporte.aiclave == 23) {
                //RLV
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '161').then(response => {
                    if (response.data.length > 0) {
                        response.data.forEach(object => {
                            if (object.peclave == 161)
                                this.desconclusionPer = true;

                        });
                    }
                });
            }
            else if (this.reporte.aiclave == 24) {
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '163').then(response => {
                    if (response.data.length > 0) {
                        response.data.forEach(object => {
                            if (object.peclave == 163)
                                this.desconclusionPer = true;

                        });
                    }
                });
            }
        },
    },
        async mounted() {
            this.user = MetodosGenerales.ObtenerUserName();
        this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
        await this.Permisos();
            this.ObtenerMenu();
    },
}
</script>
<style>
.btnProc {
    background-color: rgb(255 82 0 / 46%) !important;
}

.overBtn {
    margin-top: -10% !important;
    margin-left: -20% !important;
}

.txtEtiq {
    color: black;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}

.txtRep {
    color: white;
    padding-right: 30px;
    font-size: 18px;
}

.chipSize {
    height: 45px !important;
}

.chipSmaller {
    font-size: 10px;
}

.btnSize {
    height: 45px !important;
    width: 45px !important;
}

.marginChip {
    margin-left: -40px !important;
    margin-right: 15px !important;
    background-color: white !important;
    border-color: rgb(60, 212, 160) !important;
    border: 1px solid;
}

.marginChipRed {
    margin-left: -40px !important;
    margin-right: 15px !important;
    background-color: white !important;
    border-color: red !important;
    border: 1px solid;
}

.marginChipPurple {
    margin-left: -40px !important;
    margin-right: 15px !important;
    background-color: white !important;
    border-color: rgb(144, 19, 254) !important;
    border: 1px solid;
}

.marginChipYellow {
    margin-left: -40px !important;
    margin-right: 15px !important;
    background-color: white !important;
    border-color: rgb(255, 194, 96) !important;
    border: 1px solid;
}

@media screen and (max-width: 500px) {
    .movBtn {
        font-size: 13px !important;
    }

    .btnVehiculo {
        height: 30px !important;
        width: 30px !important;
    }

    .btnVehiculoPurple {
        height: 30px !important;
        width: 30px !important;
    }

    .txtEtiq {
        color: black;
        font-size: 12px !important;
        font-weight: bold;
        text-align: center;
    }

    .txtRep {
        font-size: 15px;
    }
}

@media screen and (max-width: 767px) {
    .txtEtiq {
        color: black;
        font-size: 12px !important;
        font-weight: bold;
        text-align: center;
    }

    .txtRep {
        font-size: 16px;
    }
}

.btnCar {
    font-size: 27px !important;
}

.reporte-menu .vs-collapse-item--header {
    background-color: #2d3e4e !important;
}

.btnBook {
    transform: rotate(90deg);
    font-size: 55px !important;
    pointer-events: none;
}

.btnVehiculo {
    background-color: #ff6a00;
    font-size: 20px !important;
    height: 45px !important;
    width: 45px !important;
    margin-left: 5px;
    margin-right: 10px;
}

.btnVehiculoPurple {
    background-color: #5a57a7;
    font-size: 20px !important;
    height: 45px !important;
    width: 45px !important;
    margin-left: 5px;
    margin-right: 10px;
}

.display-on-mobile {
    display: none !important;
}

.hide-on-mobile {
    display: block !important;
}

.childIcon {
    margin-left: -12px;
    margin-top: 25px;
}

.childIconPurple {
    margin-left: -12px;
    margin-top: 25px;
}
</style>

<style scoped>
.card-title-text {
    font-size: 1.3rem !important;
    font-weight: 500 !important;
    color: white !important;
    text-align: center !important;
    margin-top: 2px !important;
    margin-bottom: 2px !important;
}

.menu-header-bg {
    background-color: #2d3e4e !important;
}

.collapsable-container {
    background-color: white;
    height: 100% !important;
}

.title-card-style {
    padding: 1.5px !important;
    max-height: auto;
}

.main-buttons-container {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 0px;
    padding-bottom: 0px;
}
</style>
